import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import {getCountries, getSchools, getCurriculums, getCountryCode, getEmirates, getCities} from '../../actions/RegisterActions';
import {enrollStudent} from '../../actions/StudentAction'
import ProfileImg from '../../assets/images/dummy.png';
import moment from 'moment';
import { countryId} from '../../config/Constant';
import { editableInputTypes } from '@testing-library/user-event/dist/utils';

const EnrollmentForm = (props) => {
    const detail = props.detail
    const currentDate = moment().format('YYYY-MM-DD');
    const minBirthYear=moment(currentDate).subtract(25,'years').format('YYYY-MM-DD')
    const maxBirthYear=moment(currentDate).subtract(10,'years').format('YYYY-MM-DD')
    const [name, setName] = useState({ value: '', error: '', isRequired: false });
    const [dob, setDob] = useState({ value: '', error: '', isRequired: false });
    const [studentPhoto, setStudentPhoto] = useState({ value: '', error: '', isRequired: false });
    const [studentEmail, setStudentEmail] = useState({ name: 'studentEmail', value: '', error: '', isRequired: false });
    const [studentMobile, setStudentMobile] = useState({ name: 'studentMobile', value: '', error: '', isRequired: false });
    const [parentMobile, setParentMobile] = useState({ name: 'parentMobile', value: '', error: '', isRequired: false });
    const [parentEmail, setParentEmail] = useState({ name: 'parentEmail', value: '', error: '', isRequired: false });
    const [whatsappNumber, setWhatsappNumber] = useState({ name: 'whatsappNumber', value: '', error: '', isRequired: false });
    const [parentProfession, setParentProfession] = useState({ name: 'parentProfession', value: '', error: '', isRequired: false });
    const [designation, setDesignation] = useState({ name: 'designation', value: '', error: '', isRequired: false });
    const [targetExam, setTargetExam] = useState({ name: 'targetExam', value: '', error: '', isRequired: false });
    const [fatherName, setFatherName] = useState({ name: 'fatherName', value: '', error: '', isRequired: false });
    const [country, setCountry] = useState({ name: 'country', value: '', error: '', options: [], isRequired: false });
    const [cities, setCities] = useState({ value: '', error: '', options: [], isRequired: false });
    const [emirates, setEmirates] = useState({ value: '', error: '', options: [], isRequired: false });
    const [otherCityName, setOtherCityName] = useState({ value: '', error: '', isRequired: false });
    const [schools, setSchools] = useState({ value: '', error: '', options: [], isRequired: false });
    const [mobileNumber, setMobile] = useState({ value: '', error: '', options: [], isRequired: false });
    const [gender, setGender] = useState({ value: '', error: '', options: [], isRequired: false });
    const [curriculums, setCurriculums] = useState({ value: '', error: '', options: [], isRequired: false });
    const [countryCode, setCountryCode] = useState({ value: '', error: '', options: [], isRequired: false });
    const [email, setEmail] = useState({ value: '', error: '', options: [], isRequired: false });
    const [otherSchoolName, setOtherSchoolName] = useState({ value: '', error: '', options: [], isRequired: false });
    const [isOtherCity, setOtherCity] = useState(false)
    const [isOtherSchool, setIsOtherSchool] = useState(false)
    const [fieldDisabled,setFieldDisabled] = useState(false);
    

    useEffect(async () => {
        const detail = props.enrollmentDetail&& Object.keys(props.enrollmentDetail).length !== 0?props.enrollmentDetail:props.detail
        if (detail !== undefined) {
            setName({ ...name, value: detail.name })
            setDob({ ...dob, value: detail.dob })
            setStudentEmail({ ...studentEmail, value: detail.student_email })
            setStudentMobile({ ...studentMobile, value: detail.student_mobile })
            setParentMobile({ ...parentMobile, value: detail.parent_mobile })
            setParentEmail({ ...parentEmail, value: detail.parent_email })
            setWhatsappNumber({ ...whatsappNumber, value: detail.whatsapp_number })
            setParentProfession({ ...parentProfession, value: detail.parent_profession })
            setDesignation({ ...designation, value: detail.designation })
            setTargetExam({ ...targetExam, value: detail.target_exam })
            setFatherName({ ...fatherName, value: detail.father_name })
            setEmail({ ...email, value: detail.email })
            setMobile({ ...mobileNumber, value: detail.mobile_no })
            setCountryCode({ ...countryCode, value: detail.country_code })
            setGender({ ...gender, value: detail.gender })
            setOtherCityName({ ...otherCityName, value: detail.other_city })
            setOtherSchoolName({ ...otherSchoolName, value: detail.other_school })
            setStudentPhoto({...studentPhoto,value:detail.profile_picture})
            setDob({...dob,value:detail.dob})

        }
    }, [detail.name,detail.father_name,detail.email,detail.mobile_no,detail.country_code,detail.gender,detail.other_city,detail.other_school,detail.profile_picture,detail.dob])

    useEffect(async () => {
        const detail = props.detail!==undefined && props.detail
        if (detail !== undefined) {

            const countryRes = await getCountries();
            setCountry({ ...country, options: countryRes.data, value: parseInt(detail.country_id) })

            let cid=parseInt(detail.country_id)
            const emiratesRes = await getEmirates(cid)
            setEmirates({ ...emirates, options: emiratesRes.data, value: detail.emirates_id })

            const citiesRes = await getCities(parseInt(detail.country_id), parseInt(detail.emirates_id))
            setCities({ ...cities, options: citiesRes.data, value: parseInt(detail.city_id) })
            if (detail.city_id == 0) {
                setOtherCity(true)
            }

            const curriculumsRes = await getCurriculums(detail.country_id)
            setCurriculums({ ...curriculums, options: curriculumsRes.data, value: parseInt(detail.curriculums_id) })

            const countryCodeRes = await getCountryCode(parseInt(detail.country_id))
            setCountryCode({ ...countryCode, options: countryCodeRes.data, value: detail.country_code })

            const schoolRes = await getSchools(parseInt(detail.country_id))
            setSchools({ ...schools, options: schoolRes.data, value: detail.school_id })
            if (detail.school_id == 0) {
                setIsOtherSchool(true)
            }

            if(detail.is_enroll ==1){
                setFieldDisabled(true)
            }
   
        }
    }, [detail.country_id, detail.emirates_id, detail.school_id, detail.country_code, detail.curriculums_id, detail.city_id, detail.class_id, detail.course_id])
    

    const handleCountryChange = (e) => {
        setCountry({ ...country, value: e.target.value, error: '' });

        getEmirates(e.target.value)
            .then((res) => {
                setEmirates({ ...emirates, options: res.data })
            });

        getCurriculums(e.target.value)
            .then((res) => {
                setCurriculums({ ...curriculums, options: res.data })
            });

        getCountryCode(e.target.value)
            .then((res) => {
                setCountryCode({ ...countryCode, options: res.data, value: res.data.isd_code })
            });

        setCities({ ...cities, value: e.target.value, error: '' })

        setSchools({ ...schools, value: e.target.value, error: '' });
        
        setOtherCity(false)
        setIsOtherSchool(false)
    }

    const handleStateChange = (e) => {
        setEmirates({ ...emirates, value: e.target.value, error: '' });

        getCities(country.value, e.target.value)
            .then((res) => {

                setCities({ ...cities, options: res.data })
            });
    }

    const handleSchoolChange = (e) => {
        const sVal = e.target.value
        setSchools({ ...schools, value: e.target.value, error: '' });
        if (sVal == 0) {
            setIsOtherSchool(true)
        }
        else {
            setIsOtherSchool(false)
        }

    }

    const handleCurriculumChange = (e) => {
        setCurriculums({ ...curriculums, value: e.target.value, error: '' });
    }

    const handleCountryCodeChange = (e) => {
        setCountryCode({ ...countryCode, value: e.target.value, error: '' });
    }

    const handleCityChange = (e) => {
        const cVal = e.target.value
        setCities({ ...cities, value: e.target.value, error: '' })
        if (cVal == 0) {
            setOtherCity(true)
        }
        else {
            setOtherCity(false)
        }

    }

    // Validations are here  
    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let emailRegex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let formIsValid = true

        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }
        if (!gender.value) {
            formIsValid = false
            let msg = "Please select gender"
            setGender({ ...gender, error: msg })
        }
        if (!emirates.value) {
            formIsValid = false
            let msg = "Please select emirates"
            setEmirates({ ...emirates, error: msg })
        }
        
        if (!cities.value) {
            formIsValid = false
            let msg = "Please select city"
            setCities({ ...cities, error: msg })
        }
        if (cities.value==0) {
            formIsValid = true
            setCities({ ...cities, error: '' })
        }
        
        if (!schools.value) {
            formIsValid = false
            let msg = "Please select school"
            setSchools({ ...schools, error: msg })
        }
        if (schools.value==0) {
            formIsValid = true
            setSchools({ ...schools, error: '' })
        }
        if (!curriculums.value) {
            formIsValid = false
            let msg = "Please select school curriculum"
            setCurriculums({ ...curriculums, error: msg })
        }
        if (!targetExam.value) {
            formIsValid = false
            let msg = "Please select target exam"
            setTargetExam({ ...targetExam, error: msg })
        }
   
        // Student Name
        if (!name.value) {
            formIsValid = false
            let msg = "Please enter name"
            setName({ ...name, error: msg })
        }
        else if (name.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setName({ ...name, error: msg })
        }
        else if (name.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setName({ ...name, error: msg })
        }
        else if (!nameRegex.test(name.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setName({ ...name, error: msg })
        }

        // Student email
        // Email validation
        if (!studentEmail.value) {
            formIsValid = false
            let msg = "Please enter email"
            setStudentEmail({ ...studentEmail, error: msg })
        }
        else if (studentEmail.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setStudentEmail({ ...studentEmail, error: msg })
        }
        else if (studentEmail.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setStudentEmail({ ...studentEmail, error: msg })
        }

        else if (!emailRegex.test(studentEmail.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setStudentEmail({ ...studentEmail, error: msg })
        }

        // Student mobile
        if (!studentMobile.value) {
            formIsValid = false
            let msg = "Please enter mobile number"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        
        else if (studentMobile.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        else if (studentMobile.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setStudentMobile({ ...studentMobile, error: msg })
        }
        else if (!mobileRegex.test(studentMobile.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setStudentMobile({ ...studentMobile, error: msg })
        }

        // Parent Mobile
        if (!parentMobile.value) {
            formIsValid = false
            let msg = "Please enter  mobile number"
            setParentMobile({ ...parentMobile, error: msg })
        }
        
        else if (parentMobile.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setParentMobile({ ...parentMobile, error: msg })
        }
        else if (parentMobile.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setParentMobile({ ...parentMobile, error: msg })
        }
        else if (!mobileRegex.test(parentMobile.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setParentMobile({ ...parentMobile, error: msg })
        }

        // Parent Email
        if (!parentEmail.value) {
            formIsValid = false
            let msg = "Please enter your email"
            setParentEmail({ ...parentEmail, error: msg })
        }
        else if (parentEmail.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setParentEmail({ ...parentEmail, error: msg })
        }
        else if (parentEmail.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setParentEmail({ ...parentEmail, error: msg })
        }
        
        else if (!emailRegex.test(parentEmail.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setParentEmail({ ...parentEmail, error: msg })
        }
        // Whatsapp number
        if (!whatsappNumber.value) {
            formIsValid = false
            let msg = "Please enter whatsapp number"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        
        else if (whatsappNumber.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        else if (whatsappNumber.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        else if (!mobileRegex.test(whatsappNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Whatsapp Mobile Number"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }

        // Profession
        if (!parentProfession.value) {
            formIsValid = false
            let msg = "Please enter profession"
            setParentProfession({ ...parentProfession, error: msg })
        }

        // Profession
        if (!designation.value) {
            formIsValid = false
            let msg = "Please enter designation"
            setDesignation({ ...designation, error: msg })
        }

        // Dob
        // Profession
        if (!dob.value) {
            formIsValid = false
            let msg = "Please select date of birht"
            setDob({ ...dob, error: msg })
        }

        // Fahter Name
        if (!fatherName.value) {
            formIsValid = false
            let msg = "Please enter father name"
            setFatherName({ ...fatherName, error: msg })
        }
        else if (fatherName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setFatherName({ ...fatherName, error: msg })
        }
        else if (fatherName.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setFatherName({ ...fatherName, error: msg })
        }
        else if (!nameRegex.test(fatherName.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setFatherName({ ...fatherName, error: msg })
        }

        // Email validation
        if (!email.value) {
            formIsValid = false
            let msg = "Please enter your email"
            setEmail({ ...email, error: msg })
        }

        else if (email.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setEmail({ ...email, error: msg })
        }
        else if (email.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setEmail({ ...email, error: msg })
        }

        else if (!emailRegex.test(email.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setEmail({ ...email, error: msg })
        }

        // Phone number
        if (!mobileNumber.value) {
            formIsValid = false
            let msg = "Please enter your mobile number"
            setMobile({ ...mobileNumber, error: msg })
        }

        else if (mobileNumber.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setMobile({ ...mobileNumber, error: msg })
        }
        else if (mobileNumber.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setMobile({ ...mobileNumber, error: msg })
        }
        else if (!mobileRegex.test(mobileNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setMobile({ ...mobileNumber, error: msg })
        }


        // Other City
        // if (otherCityName.value!==null && otherCityName.value.length <= 2) {
        //     formIsValid = false
        //     let msg = "Min 3 Number Length"
        //     setOtherCityName({ ...otherCityName, error: msg })
        // }
        // else if (otherCityName.value!==null && otherCityName.value.length >= 50) {
        //     formIsValid = false
        //     let msg = "Max 50 Number Length"
        //     setOtherCityName({ ...otherCityName, error: msg })
        // }

        // Other School
        // if (otherSchoolName.value!==null && otherSchoolName.value.length <= 2) {
        //     formIsValid = false
        //     let msg = "Min 3 Number Length"
        //     setOtherSchoolName({ ...otherSchoolName, error: msg })
        // }
        // else if (otherSchoolName.value!==null && otherSchoolName.value.length >= 50) {
        //     formIsValid = false
        //     let msg = "Max 50 Number Length"
        //     setOtherSchoolName({ ...otherSchoolName, error: msg })
        // }
        if (formIsValid) {
            setName({ ...name, error: '' });
            setDob({ ...dob, error: '' });
            setStudentEmail({ ...studentEmail, error: '' });
            setStudentMobile({ ...studentMobile, error: '' });
            setParentMobile({ ...parentMobile, error: '' });
            setParentEmail({ ...parentEmail, error: '' });
            setWhatsappNumber({ ...whatsappNumber, error: '' });
            setParentProfession({ ...parentProfession, error: '' });
            setDesignation({ ...designation, error: '' });
            setTargetExam({ ...targetExam, error: '' });
            setFatherName({ ...fatherName, error: '' })
            setEmail({ ...email, error: '' })
            setMobile({ ...mobileNumber, error: '' })
            setGender({ ...gender, error: '' })
            setCities({ ...cities, error: '' })
            setSchools({ ...schools, error: '' })
            setCurriculums({ ...curriculums, error: '' })
            setEmirates({ ...emirates, error: '' })
            // setOtherCityName({ ...otherCityName, error: '' })
            // setOtherSchoolName({ ...otherSchoolName, error: '' })
        }
        return formIsValid;

    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (validation()) {
            const data = {
                name: name.value,
                emirates_id: emirates.value,
                city_id: cities.value,
                country_id: country.value,
                email: email.value,
                mobile_no: mobileNumber.value,
                school_id: schools.value,
                gender: gender.value,
                father_name: fatherName.value,
                curriculums_id: curriculums.value,
                study_abroad: 1,
                country_code: countryCode.value,
                other_city: otherCityName.value ? otherCityName.value : '',
                other_school: otherSchoolName.value ? otherSchoolName.value : '',
                student_email:studentEmail.value,
                student_mobile:studentMobile.value,
                dob:dob.value,
                profile_picture:studentPhoto.value,
                parent_mobile:parentMobile.value,
                parent_email:parentEmail.value,
                whatsapp_number:whatsappNumber.value,
                parent_profession:parentProfession.value,
                designation:designation.value,
                target_exam:targetExam.value,
                id:detail.id
            }

            props.onSubmit(data)
        }
    }
    return (
        <>
            <form onSubmit={onSubmit} className="hold_mandatoryField">
                <div className='row'>
                <div className="col-lg-6 mx-auto mb-3 text-center">
                        {detail.profile_picture?
                        <img src={`${process.env.REACT_APP_API_URL}/public/uploads/profile_picture/${detail.profile_picture}`} style={{width:'inherit'}} alt="Profile" className="w-25 rounded-circle" />
                        :<>
                        <img src={ProfileImg} style={{width:'inherit'}} alt="Profile" className="rounded-circle w-25" />
                        <div className="form-floating diff_disable">
                        <div className="icon-edit-profile" style={{right:"35%"}}>
                        <label  htmlFor="profileImg" className="label optional  position-relative">
                            <input type="file" id="profileImg" className="form-control d-none" name="studentPhoto"
                                placeholder="Student Photo" accept="image/png, image/gif, image/jpeg" value={studentPhoto.value} onChange={(e) =>
                                    setStudentPhoto({ ...studentPhoto, value: e.target.value, error: '' })}
                            />
                            <FontAwesomeIcon  icon={faCamera}/>
                            </label>
                            </div>
                        </div></>}
                        {studentPhoto.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentPhoto.error}</div>}
                    </div>
                </div>
                <div className='row'>
                    <div className="col-lg-12 mb-3">
                        <div className="form-floating diff_disable">
                            <select className="form-select" disabled name="country" value={country.value}
                                onChange={handleCountryChange}>
                                <option>Please select country</option>
                                {country.options.map(item => <option key={item.id} value={item.id}>{item.name}
                                </option>)}
                            </select>
                            <label>Select country</label>
                        </div>
                        {country.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{country.error}</div>}
                    </div>

                </div>

                <div className="row mb-4">

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="name"
                                placeholder="Student's Full Name" disabled value={name.value} onChange={(e) =>
                                    setName({ ...name, value: e.target.value, error: '' })}
                            />
                            <label>Student's Full Name</label>
                        </div>
                        {name.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{name.error}</div>}
                    </div>

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="date" min={minBirthYear}  max={maxBirthYear} disabled={fieldDisabled} className="form-control" name="dob"
                                placeholder="Date of birth" value={dob.value} onChange={(e) =>
                                    setDob({ ...dob, value: e.target.value, error: '' })}
                            />
                            <label>Date of birth</label>
                        </div>
                        {dob.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{dob.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="studentEmail"
                                placeholder="Student's Email" disabled={fieldDisabled}  value={studentEmail.value} onChange={(e) =>
                                    setStudentEmail({ ...studentEmail, value: e.target.value, error: '' })} 
                            />
                            <label className='optional'>Student's Email</label>
                        </div>
                        {studentEmail.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentEmail.error}</div>}
                    </div>

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="studentMobile"
                                placeholder="Student's Mobile" maxLength="16"  disabled={fieldDisabled} value={studentMobile.value} onChange={(e) =>
                                    setStudentMobile({ ...studentMobile, value: e.target.value, error: '' })} 
                            />
                            <label className='optional'>Student's Mobile</label>
                        </div>
                        {studentMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentMobile.error}</div>}
                    </div>

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" disabled name="fatherName" placeholder="Father Name"
                                value={fatherName.value} onChange={(e) =>
                                    setFatherName({ ...fatherName, value: e.target.value, error: '' })}
                            />
                            <label>Father Name/Mother Name</label>
                        </div>
                        {fatherName.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{fatherName.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="parentMobile"
                                placeholder="Parent Mobile Number"  disabled={fieldDisabled} maxLength="16" value={parentMobile.value} onChange={(e) =>
                                    setParentMobile({ ...parentMobile, value: e.target.value, error: '' })} 
                            />
                            <label >Parent Mobile Number</label>
                        </div>
                        {parentMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentMobile.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="parentEmail" 
                                placeholder="Student's Mobile"  disabled={fieldDisabled} value={parentEmail.value} 
                                onChange={(e) =>
                                    setParentEmail({ ...parentEmail, value: e.target.value, error: '' })} 
                            />
                            <label >Parent Email Id</label>
                        </div>
                        {parentEmail.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentEmail.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="whatsNumber"
                                placeholder="WhatsApp Number" disabled={fieldDisabled} value={whatsappNumber.value} 
                                maxLength="16"
                                onChange={(e) =>
                                    setWhatsappNumber({ ...whatsappNumber, value: e.target.value, error: '' })} 
                            />
                            <label >WhatsApp Number</label>
                        </div>
                        {whatsappNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{whatsappNumber.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="parentProfession"
                                placeholder="parent profession"  disabled={fieldDisabled} value={parentProfession.value}
                                onChange={(e) =>
                                    setParentProfession({ ...parentProfession, value: e.target.value, error: '' })} 
                            />
                            <label >Parent Profession</label>
                        </div>
                        {parentProfession.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentProfession.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" name="designation"
                                placeholder="parent profession"  disabled={fieldDisabled} value={designation.value}
                                onChange={(e) =>
                                    setDesignation({ ...designation, value: e.target.value, error: '' })} 
                            />
                            <label >Designation</label>
                        </div>
                        {designation.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{designation.error}</div>}
                    </div>

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <select value={targetExam.value}  disabled={fieldDisabled} className="form-select" name="targetExam" 
                            onChange={(e) =>
                                setTargetExam({ ...targetExam, value: e.target.value,error :'' })}
                                >
                                <option value="">Choose</option>
                                <option value="jee">JEE</option>
                                <option value="neet">NEET</option>
                                <option value="foundation">FOUNDATION</option>
                            </select>
                            <label>Target Exam</label>
                        </div>
                        {targetExam.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{targetExam.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input type="text" className="form-control" disabled name="email" placeholder="Email"
                                value={email.value} onChange={(e) => setEmail({ ...email, value: e.target.value, error: '' })}
                            />
                            <label>Email Address</label>
                        </div>
                        {email.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{email.error}</div>}
                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className='d-flex '>
                            <div className="form-floating diff_disable d-inline">
                                <input type="text" className="form-control rounded-start rounded-0 px-2"
                                    name="countryCode" readOnly placeholder="Country code" value={countryCode.value}
                                    onChange={(e) => setCountryCode({ ...countryCode, value: e.target.value })}
                                />
                                <label className='px-2'>Country Code</label>
                            </div>
                            <div className="form-floating diff_disable ms-1 w-100 d-inline">
                                <input type="text" readOnly className="form-control rounded-end rounded-0" name="mobileNumber"
                                    placeholder="Mobile number" value={mobileNumber.value} onChange={(e) =>
                                        setMobile({ ...mobileNumber, value: e.target.value, error: '' })}
                                />
                                <label>Mobile No</label>
                            </div>
                        </div>

                        {mobileNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{mobileNumber.error}</div>}

                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <select value={gender.value} disabled className="form-select" name="gender" onChange={(e) =>
                                setGender({ ...gender, value: e.target.value, error : '' })}>
                                <option value="">Please Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                            <label>Gender</label>
                        </div>
                        {gender.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{gender.error}</div>}
                    </div>

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <select value={emirates.value} disabled className="form-select" name="emirates"
                                onChange={handleStateChange}>
                                <option>Select Emirates</option>
                                {emirates.options && emirates.options.map(item => <option key={item.id} value={item.id}>{item.name}
                                </option>)}
                            </select>
                            <label>Emirate/Governate</label>
                        </div>
                        {emirates.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{emirates.error}</div>}

                    </div>
                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <select value={cities.value} disabled className="form-select" name="emirates" onChange={handleCityChange}>
                                <option>Select City</option>
                                {cities.options && cities.options.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                            </select>
                            <label>City</label>
                        </div>
                        {cities.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{cities.error}</div>}
                    </div>

                    {isOtherCity && <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input
                                type="text"
                                className="form-control"
                                name="otherCityName"
                                placeholder="Other City Name"
                                disabled
                                value={otherCityName.value}
                                onChange={(e) => setOtherCityName({ ...otherCityName, value: e.target.value, error: '' })}
                            />
                            <label >Other City Name</label>
                        </div>
                        {otherCityName.error.length > 0 && <div className='invalidFeedback'>{otherCityName.error}</div>}
                    </div>}

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <select value={schools.value} disabled className="form-select" name="schoolName"
                                onChange={handleSchoolChange}>
                                <option>Select School</option>
                                {schools.options && schools.options.map(item => <option key={item.id} value={item.id}>{item.name}
                                </option>)}
                            </select>
                            <label>School</label>
                        </div>
                        {schools.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{schools.error}</div>}
                    </div>
                    {isOtherSchool && <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable">
                            <input
                                type="text"
                                className="form-control"
                                name="otherSchoolName"
                                disabled
                                placeholder="Other School Name"
                                value={otherSchoolName.value}
                                    onChange={(e) => setOtherSchoolName({ ...otherSchoolName, value: e.target.value, error: '' })}
                            />
                            <label >Other School Name</label>
                        </div>
                        {otherSchoolName.error.length > 0 && <div className='invalidFeedback'>{otherSchoolName.error}</div>}
                    </div>}

                    <div className="col-lg-6 mb-3">
                        <div className="form-floating diff_disable diff_disable">
                            <select value={curriculums.value} disabled className="form-select" name="schoolCurriculum"
                                onChange={handleCurriculumChange}>
                                <option>Select School Curriculum</option>
                                {curriculums.options && curriculums.options.map(item => <option key={item.id} value={item.id}>
                                    {item.name}</option>)}
                            </select>
                            <label>School Curriculum</label>
                        </div>
                        {curriculums.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{curriculums.error}</div>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12  text-center text-sm-start col-12 mb-3">
                        <button type="submit"  disabled={fieldDisabled} className="btn btn-primary btn-lg register_btn me-3">Submit</button>
                        <Link to="/dashboard" className="btn btn-secondary btn-lg mt-3 mt-sm-0 register_btn">Back to Dashboard</Link>
                    </div>
                </div>
            </form>

        </>

    )


}

export default EnrollmentForm
